export const THEME = {
  DARK: "dark",
  LIGHT: "light"
};

export const PRIMARY_COLOR = {
  DARK: "#69f0ae",
  LIGHT: "#0277bd"
};
export const SECONDARY_COLOR = {
  DARK: "#FFCF44",
  LIGHT: "#ffb300"
};
export const ERROR_COLOR = {
  DARK: "#ff1744",
  LIGHT: "#d32f2f"
};
export const WARNING_COLOR = {
  DARK: "ff1744",
  LIGHT: "#d32f2f"
}